/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2024-03-06 15:46:03
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-09-04 11:59:18
 */
const license = {
  title: 'Apply for a licence',
  des: '',
  form: {
    des: 'If you are interested in our products, you can request a product trial by providing your information.',
    title: 'Basic Information',
    topic: {
      label: 'Topic',
      placeholder: 'Please Select',
      required: ['Please select']
    },
    serialNumber: {
      label: 'Serial Number',
      placeholder: 'Please input…',
      required: ['This field must be filled!', 'Serial number error']
    },
    institution: {
      label: 'Institution Name',
      placeholder: 'Please input…',
      required: ['This field must be filled!']
    },
    profession: {
      label: 'Profession',
      placeholder: 'Please Select',
      required: ['Please select']
    },
    surname: {
      label: 'First Name',
      placeholder: 'Please input…',
      required: ['This field must be filled!']
    },
    name: {
      label: 'Last Name',
      placeholder: 'Please input…',
      required: ['This field must be filled!']
    },
    country: {
      label: 'Country',
      placeholder: 'Please Select',
      required: ['Please select']
    },
    address: {
      label: 'Address',
      placeholder: 'Please input…',
      required: ['This field must be filled!']
    },
    province: {
      label: '',
      placeholder: '',
      required: ['Please select']
    },
    city: {
      label: '',
      placeholder: '',
      required: ['Please select']
    },
    contactInformation: {
      title: 'Contacts',
      telephone: 'By Mobile',
      email: 'By E-mail'
    },
    areaCode: {
      label: 'Please Select',
      placeholder: 'Please Select',
      required: ['Please select']
    },
    telephone: {
      label: 'Please Select',
      placeholder: 'Please input…',
      required: ['This field must be filled!', 'Invalid mobile']
    },
    email: {
      label: 'E-mail',
      placeholder: 'Please input…',
      required: ['This field must be filled!', 'E-mail error']
    },
    invitationCode: {
      label: 'Invitation Code',
      placeholder: 'Please input…',
      required: ['This field must be filled!', 'Invitation code error']
    }
  },
  formData: {
    topic: {
      probation: 'Apply for trial',
      code: 'Get activation code'
    },
    profession: {
      physician: { name: 'Doctor', value: '医师' },
      technician: { name: 'Technician', value: '医学技师' },
      scientificResearch: { name: 'Researcher', value: '科研人员' },
      other: { name: 'Others', value: '其他' }
    }
  },
  product: {
    title: 'Product Model',
    warn: '(Please enter the correct serial number first)',
    error: 'Please select product',
    skull: {
      title: 'Cerebrovasular Product Portfolio',
      bjImg: require('@/assets/images/license/skull_bj.png'),
      list: [
        { name: ['AneuFlow', 'Series'], type: 'AneuFlow', img: require('@/assets/images/license/AneuFlow_Series.png') },
        { name: ['AneuGuide'], type: 'AneuGuide', img: require('@/assets/images/license/AneuGuide.png') },
        { name: ['AneuShape'], type: 'AneuShape', img: require('@/assets/images/license/AneuShape.png') },
        { name: ['AccuICAS'], type: 'AccuFFicas', img: require('@/assets/images/license/AccuICAS.png') },
        { name: ['AneuPlan'], type: 'AneuPlan', img: require('@/assets/images/license/AneuPlan.png') },
        { name: ['AccuASPECTS'], type: 'AccuASPECTS', img: require('@/assets/images/license/AccuASPECTS.png') },
        { name: ['AccuCTP'], type: 'AccuCTP', img: require('@/assets/images/license/AccuCTP.png') }
      ]
    },
    heart: {
      title: 'Cardiovascular Product Portfolio',
      bjImg: require('@/assets/images/license/heart_bj.png'),
      list: [
        { name: ['AccuFFRct', 'Series'], type: 'AccuFFRct', img: require('@/assets/images/license/AccuFFRct_Series.png') },
        { name: ['AccuFFRangio', 'Series'], type: 'AccuFFRangio', img: require('@/assets/images/license/AccuFFRangio_Series.png') },
        { name: ['AccuFFRoct', 'Series'], type: 'AccuFFRoct', img: require('@/assets/images/license/AccuFFRoct_Series.png') },
        { name: ['AccuFFRivus', 'Series'], type: 'AccuFFRivus', img: require('@/assets/images/license/AccuFFRivus_Series.png') },
        { name: ['AccuLV'], type: 'AccuLV', img: require('@/assets/images/license/AccuLV.png') },
        { name: ['AccuIMR'], type: 'AccuIMR', img: require('@/assets/images/license/AccuIMR.png') }
      ]
    }
  },
  textarea: {
    title: 'Note',
    placeholder: 'Please input…'
  },
  checked: {
    text: ['We process your personal data in accordance with the applicable legislation governing', 'the use of personal data. You can read more in the '],
    sign: 'Privacy Policy.',
    tooltip: 'You need to read and agree to the ArteryFlow Privacy Policy'
  },
  submit: 'Submit Information',
  submiting: 'Submitting, please wait.',
  results: {
    succ: ['Thank you for contacting ArteryFlow Technology, ', 'your information has been submitted. We will contact you soon!'],
    warn: ['You have exceeded the submission limit, Please don’t submit it again...'],
    err: ['The submission failed because the data is abnormal']
  },
  policy: {
    list: [
      ['1.Privacy Policy for ArteryFlow', 'ArteryFlow Technology Co., Ltd. (hereinafter referred to as "ArteryFlow") respects your privacy rights. We commit to using personal data related to all stakeholders in a responsible manner. To achieve this, we adhere to data protection laws, and our employees and suppliers also follow internal privacy rules and policies.'],
      ['2.About This Policy', 'This privacy policy aims to introduce how we collect, use, store, share, and protect your personal information when you engage in online consultations with us through our website. Before submitting online inquiries or any personal information, please carefully read and understand this privacy policy. By clicking “Submit Information” during an online consultation, we will consider that:', '<li style="list-style: initial;">You have understood and agreed to the content of this privacy policy.</li>', '<li style="list-style: initial;">You consent to ArteryFlow collecting, using, and sharing your personal information as described in this privacy policy.</li>', '<li style="list-style: initial;">You acknowledge that all information you provide to us is true and accurate. Any inaccurate information you provide may affect our subsequent communication and feedback with you.</li>'],
      ['3.Applicable Data Protection Laws', 'ArteryFlow operates in multiple jurisdictions, and visitors from different countries can access our website. This policy aims to provide notifications regarding personal information to data subjects, striving to comply with the strictest data protection laws in the jurisdictions where ArteryFlow operates. As a data controller, ArteryFlow processes personal information based on the purposes and methods described in this privacy policy.'],
      ['4.Legality of Processing Personal Information', 'When you use the “Trial & Activation” feature to submit questions or suggestions, you explicitly grant us permission (legally referred to as “consent”) to use the relevant information you provide for the purpose of providing responses. Of course, you can withdraw your consent at any time. If ArteryFlow has legal or regulatory obligations to record or disclose information collected on this website, the legality of processing personal information becomes a legal obligation that ArteryFlow must comply with.'],
      ['5.Collection of Personal Information', '<li style="list-style: initial;">When you use our products, we and our affiliated companies process your personal data as a user and product holder for the following purposes, including contact information and identity information:</li>', 'a) Providing software, services, or information to you.', 'b) Protecting us from piracy and illegal use of our software or services.', 'c) Improving our products based on usage.', 'd) Internal evidence and protecting the rights of us and other users.', 'e) Promoting and marketing our software and services.', 'f) Fulfilling accounting, tax, and other legal obligations.', 'You can object to the processing of your personal data for purposes (a) to (f).', '<li style="list-style: initial;">For the above purposes, ArteryFlow may use your name, email, phone number, username, physical address, IP address, MAC address, etc.</li>'],
      ['6.Security of Personal Information', 'To protect your privacy, ArteryFlow takes network security measures when processing personal information shared with us. These necessary measures are technical and organizational, aimed at preventing alteration, loss, and unauthorized access to your data.'],
      ['7. Sharing of Personal Information', 'Without your permission, ArteryFlow will not share your personal information collected from this website with unrelated third parties. However, during the normal operation of our website, we may instruct subcontractors to process personal information on our behalf. ArteryFlow and these subcontractors implement appropriate contracts and other measures to protect your personal information. Specifically, subcontractors can only process your personal information according to our written instructions, and they must implement technical and organizational security measures to protect your data.'],
      ['8. Retention Period', 'We will retain your personal information based on the purpose of obtaining it and in accordance with data protection laws and good practices. For example, we may store and process personal information during the period of our relationship with you and while providing products and services to you. ArteryFlow may be required to archive certain personal information within the time frame of legal or regulatory obligations we must comply with. After the data retention period expires, ArteryFlow will delete and no longer store your personal information.'],
      ['9.Your Rights Regarding Personal Information', 'Within the scope permitted by applicable law, as a data subject, you can request to query, copy, correct, supplement, delete your personal information, and ask us to transfer part of your personal information to other organizations. In some cases, these rights may be limited, such as when other legal bases exist or specific legal regulations apply. If you wish to exercise your rights or have any questions about your rights as a data subject, please contact +86-571-88106256.'],
      ['10.Policy Updates', 'This policy may be updated from time to time to adapt to changes in laws or regulations related to personal information. We will indicate the update date of the policy. Revised policies will be published on our website. Any changes will take effect immediately after the revised policy is published. By continuing to use the “Coopetate”.']
    ],
    date: 'Update date：November 2nd，2023'
  }
}

export default license
